<template>
    <div class="container pl-6">
        <v-tabs
            v-model="tab"
            tile
            class="pa-0"
            height="35"
            :background-color="$vuetify.theme.dark ? 'black' : 'grey lighten-1'"
        >
            <v-tab
                v-for="item in markets"
                :key="item.tab"
                class="caption pa-0 grey--text font-weight-bold"
            >
                {{ $t(item.tab) }}
            </v-tab>
            <v-tabs-items v-model="tab" class="transparent">
                <v-tab-item v-for="item in markets" :key="item.tab">
                    <v-card flat class="transparent">
                        <v-card-text class="px-0 mt-2">
                            <component :is="item.content"></component>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </div>
</template>

<script>
import About from "@/components/fairplay/markets/Football/About"
import Tutorial from "@/components/fairplay/markets/Football/Tutorial"
import Upcoming from "@/components/fairplay/markets/Football/Upcoming"
export default {
    components: { About, Tutorial, Upcoming },
    data() {
        return {
            tab: 0,
            markets: [
                {
                    tab: "market.about_market",
                    content: "About"
                }
                // {
                //   tab: 'Tutorials',
                //   content: 'Tutorial'
                // },
                // {
                //   tab: 'Upcoming Markets',
                //   content: 'Upcoming'
                // }
            ]
        }
    },
    head() {
        return {
            title: `Play Soccer Online with ${process.env.APP_TITLE} | Enjoy Exciting Cash Winning Games`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: `If you’re looking for the best betting sites for football, join ${process.env.APP_TITLE} – your one-stop solution to sports betting and the most advanced live online casino in India.`
                },
                {
                    name: "keywords",
                    content: `online football games, play football online, online football championship, play soccer online, online soccer games, best betting sites for football`
                }
            ]
        }
    }
}
</script>
